import React, { useState } from 'react';
import { Icon } from 'components/common';
import { icons } from 'assets';
import { LAYER_COLOR_SCHEMES } from 'constants/layer-colors';

const LayerColorInfo: React.FC = () => {
  const [isColorInfoExpanded, setIsColorInfoExpanded] = useState(false);

  return (
    <div
      style={{
        padding: '8px 12px',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'max-width 0.3s ease',
        width: '100%'
      }}
      onClick={() => setIsColorInfoExpanded(!isColorInfoExpanded)}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          fontSize: '12px',
          fontWeight: 600,
          color: '#333'
        }}
      >
        <span>Layer Colors</span>
        <Icon icon={isColorInfoExpanded ? icons.arrowDown : icons.arrowRight} />
      </div>

      {isColorInfoExpanded && (
        <div
          style={{
            marginTop: '10px',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '8px',
            maxHeight: '300px',
            overflowY: 'auto'
          }}
        >
          {LAYER_COLOR_SCHEMES.map((color, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '11px'
              }}
            >
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  backgroundColor: color,
                  borderRadius: '3px',
                  border: '1px solid rgba(0,0,0,0.1)',
                  flexShrink: 0
                }}
              />
              <span
                style={{
                  color: '#666',
                  fontWeight: 500
                }}
              >
                #{Number(index) + 1}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayerColorInfo;
